export default __webpack_public_path__ + "right-bg2aff89c.png";